import { contextFactory } from '@frontend/design-system';
import { usePlatformComponentContext, useProcessorDataContext } from '../../../contexts';
import { usePaymentMethodsJustifi } from '../hooks/use-payment-methods-justifi';
import { usePaymentMethodsJustifiApi } from '../hooks/use-payment-methods-justifi-api';
import { useSelectDefaultPaymentMethod } from '../hooks/use-select-default-payment-method';
import { PaymentMethodsAdditionalJustifiContext, PaymentMethodsBaseContext } from '../types/provider.types';
import { usePaymentMethodsStateContext } from './payment-methods-state.context';
import { PaymentMethodsProviderProps } from './payment-methods.context';

export type PaymentMethodsJustifiContextValue = PaymentMethodsBaseContext & PaymentMethodsAdditionalJustifiContext;

export const [PaymentMethodsJustifiContext, usePaymentMethodsJustifiContext] =
  contextFactory<PaymentMethodsJustifiContextValue>('', {} as PaymentMethodsJustifiContextValue);

export type PaymentMethodsJustifiProviderProps = PaymentMethodsProviderProps;

export const PaymentMethodsJustifiProvider = ({ children, isPublic, ...props }: PaymentMethodsJustifiProviderProps) => {
  const { locationId } = usePlatformComponentContext();

  const { paymentsUrl } = useProcessorDataContext();

  const api = usePaymentMethodsJustifiApi({ isPublic });

  const { selectedPaymentMethod, setSelectedPaymentMethod, setView } = usePaymentMethodsStateContext();

  const value = usePaymentMethodsJustifi({
    ...props,
    locationId,
    paymentsUrl,
    api,
    selectedPaymentMethod,
    onSelectPaymentMethod: setSelectedPaymentMethod,
    onChangeView: setView,
  });

  useSelectDefaultPaymentMethod({
    onSelectPaymentMethod: value.onSelectPaymentMethod,
    selectedPaymentMethod,
    defaultPaymentMethod: value.defaultPaymentMethod,
  });

  return <PaymentMethodsJustifiContext.Provider value={value}>{children}</PaymentMethodsJustifiContext.Provider>;
};
